import { OK, CREATED, INTERNAL_SERVER_ERROR } from "../constants/response-status-codes";
import { genericError } from "../models/GenericError";
import { StoreEntityResult } from "../models/services/StoreEntityResult";
import { convertTextPwdToBase64Pwd } from "../utilities/Validation";
import { apiConnector } from "./presetService";
import { processServerError, getConstraintViolation } from "./utilities/ServiceError";

/**
 * A generic function to inject a transaction.
 * @param masterId - the master id
 * @param deviceId - the device id
 * @param enforceValidTags - true means we only accept valid tags; false means we prefer valid but accept all.
 * @param eventTypeId - optional, if not passed default will be Allowed Normal In or Allowed Normal Out based on the device
 * @param tagId - optional, if not passed we will lookup a tag using the masterId
 * @returns 
 */
export const injectTransack = async (masterId: string, deviceId: string, enforceValidTags: boolean, eventTypeId?: string, tagId?: string): 
    Promise<{ status: number, message: string, success: boolean }> => {
    try {
        const record = {
            type: "injectTransack",
            relationships: {
                deviceId: deviceId,
                masterId: masterId,
                tagId: tagId,
                eventTypeId: eventTypeId, //This is optional, if it not passed default will be Allowed Normal In or Allowed Normal Out based on the device
                enforceValidTag: (enforceValidTags === true) ? "1" : "0"
            }
        }

        const url = "";
        const response = await apiConnector.sendData(url, true, record, true)

        return new Promise(async (resolve, reject) => {
            if (response) {
                if (response.status === OK || response.status === CREATED) {
                    return resolve({ status: response.status, message: "", success: true })
                } else {
                    if (response.body) {
                        if (response.statusText) {
                            const content = await response.json()
                            return reject({ status: response.status, success: false, message: content.errors.map(error => getConstraintViolation(error.detail)) })
                        } else {
                            return reject({ status: response.status, message: genericError, success: false });
                        }
                    } else {
                        return reject({ status: response.status, message: genericError, success: false });
                    }
                }
            } else {
                return reject({ status: INTERNAL_SERVER_ERROR, message: genericError, success: false });
            }
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}

export const acknowledgeAlarm = async (transackIds: string[], password: string): Promise<StoreEntityResult> => {
    try {
        const newRecord = {
            type: "acknowledgeAlarm",
            attributes: {
                transackIds: transackIds,
                password: convertTextPwdToBase64Pwd(password),
            }
        }

        let response: any;
        const url = '';

        await apiConnector.sendData(url, true, newRecord, true).then(data => {
            response = data;
        }).catch(error => {
            return new Promise((resolve, reject) => {
                reject(processServerError(error));
            });
        });

        return new Promise<StoreEntityResult>(async (resolve, reject) => {
            if (response) {
                if (response.ok === false) {
                    const content = await response.json();
                    return reject({
                        status: response.status,
                        message: getConstraintViolation(content.errors[0].detail) ?? genericError
                    });
                }

                return resolve({ id: 0, success: true });
            }

            return reject({ status: response.status, message: genericError});
        })
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}